module.exports = __webpack_public_path__ + "media/images/top-parts-08-03d977a158496bfde9cb7b8d1decc7ce.jpg";